import {isNextRouterError} from 'next/dist/client/components/is-next-router-error'
import {ApiError} from '@/src/ports/services/api'

export const isUnauthorizedError = (error: unknown): error is ApiError =>
  error instanceof ApiError && error.httpCode === 401

export const isNavigationError = (error: unknown): boolean =>
  isNextRouterError(error) || (error instanceof Error && error.message === 'PAGE_REDIRECT')

// Also recognize legacy wrappers so they cannot turn navigation into an incident.
export function isExpectedError(error: unknown): boolean {
  const seen = new Set<unknown>()
  while (error instanceof Error && !seen.has(error)) {
    seen.add(error)
    if (isNavigationError(error) || isUnauthorizedError(error)) return true
    error = error.cause
  }
  return false
}

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (typeof window === 'undefined' || failureCount >= 2 || isExpectedError(error)) return false
  if (error instanceof ApiError) {
    return error.httpCode === 408 || error.httpCode === 429 || error.httpCode >= 500
  }
  return error instanceof TypeError && /fetch|network|load failed/i.test(error.message)
}
